// P1-017: Single formation slot — horizontal bar style
import type { OwnedAgent } from '../stores/agentStore';
import { typeAbbr, typeLabelCN, typeBgColor } from '../utils/agent-ui-helpers';

interface AgentSlotProps {
  agent: OwnedAgent | null;
  index: number;
  onClickEmpty?: (index: number) => void;
  onRemove?: (index: number) => void;
}

export function AgentSlot({ agent, index, onClickEmpty, onRemove }: AgentSlotProps) {
  if (!agent) {
    return (
      <div
        className="agent-slot"
        onClick={() => onClickEmpty?.(index)}
        title="点击部署"
      >
        <span className="agent-slot__empty-text">
          SLOT {index + 1} — DRAG AGENT HERE
        </span>
      </div>
    );
  }

  const tc = agent.type.toLowerCase();

  return (
    <div
      className={`agent-slot agent-slot--filled agent-slot--${tc}`}
      onClick={() => onRemove?.(index)}
      title="点击移除"
    >
      <div
        className="agent-slot__badge"
        style={{ background: typeBgColor(agent.type) }}
      >
        {typeAbbr(agent.type)}
      </div>
      <div className="agent-slot__info">
        <span className="agent-slot__name">{agent.name}</span>
        <span className="agent-slot__meta">
          SLOT {index + 1} · {typeLabelCN(agent.type)} · LV.{agent.level}
        </span>
      </div>
    </div>
  );
}
